module.exports = __webpack_public_path__ + "img/pexels-photomix-company-106344-com.c7fb6b90.jpg";